export default __webpack_public_path__ + "static/media/ingles deshabilitado_1.c094a103.png";